/* PepperPrints — Sezione prodotto: modale guida colori e anteprima personalizzazione.
   Modulo separato da pp-main-product.js: non tocca varianti, galleria né invio al
   carrello, e se qui qualcosa va storto il resto della scheda prodotto continua a
   funzionare. */

(function () {
  'use strict';

  var toArray = function (list) {
    return Array.prototype.slice.call(list || []);
  };

  /* ---------- Modale guida colori ---------- */

  function bindGuide(root) {
    var dialog = root.querySelector('[data-pp-guide-dialog]');
    var openers = toArray(root.querySelectorAll('[data-pp-guide-open]'));
    if (!dialog || !openers.length) return;

    var opener = null;
    var native = typeof dialog.showModal === 'function';

    function open(button) {
      opener = button;
      if (native) {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.body.classList.add('pp-modal-open');
    }

    function close() {
      if (native && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        document.body.classList.remove('pp-modal-open');
        if (opener && typeof opener.focus === 'function') opener.focus();
      }
    }

    openers.forEach(function (button) {
      button.addEventListener('click', function () {
        open(button);
      });
    });

    toArray(dialog.querySelectorAll('[data-pp-guide-close]')).forEach(function (button) {
      button.addEventListener('click', close);
    });

    // Clic sul backdrop: l'evento arriva al <dialog> stesso solo se il puntatore
    // è fuori dal riquadro interno, quindi il confronto sul target basta.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('pp-modal-open');
      if (opener && typeof opener.focus === 'function') opener.focus();
    });

    // ESC lo gestisce già <dialog>; serve solo nel ramo di riserva.
    if (!native) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && dialog.hasAttribute('open')) close();
      });
    }
  }

  /* ---------- Anteprima personalizzazione ---------- */

  function bindPreview(root) {
    var preview = root.querySelector('[data-pp-preview]');
    if (!preview) return;

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var rows = toArray(preview.querySelectorAll('[data-pp-preview-row]'));
    if (!rows.length) return;

    var dots = preview.querySelector('[data-pp-preview-dots]');
    var progress = preview.querySelector('[data-pp-preview-progress]');
    var done = preview.querySelector('[data-pp-preview-done]');
    var emptyLabel = preview.dataset.emptyLabel || '—';
    var progressSuffix = preview.dataset.progressSuffix || '';

    // Una sola lettura del form per ridipintura: le proprietà sono poche ma il
    // listener gira a ogni tasto premuto.
    function readProperties() {
      var map = {};
      toArray(form.querySelectorAll('[name^="properties["]')).forEach(function (el) {
        var match = el.name.match(/^properties\[(.+)\]$/);
        if (!match) return;
        var key = match[1];

        if (el.type === 'radio' || el.type === 'checkbox') {
          if (el.checked) map[key] = { value: el.value, swatch: el.dataset.swatch || '' };
          return;
        }

        var value = String(el.value == null ? '' : el.value).trim();
        if (value !== '') map[key] = { value: value, swatch: '' };
      });
      return map;
    }

    // Il valore arriva da impostazioni di sezione, non dal visitatore: si scrive
    // comunque via DOM invece che via innerHTML, così non c'è un solo punto in cui
    // del testo diventa markup.
    function paintValue(cell, entry, isColor) {
      cell.textContent = '';

      if (!entry) {
        cell.textContent = emptyLabel;
        return;
      }

      if (isColor && entry.swatch) {
        var chip = document.createElement('i');
        chip.className = 'pp-pdp__preview-chip';
        chip.style.setProperty('--pp-chip', entry.swatch);
        cell.appendChild(chip);
      }

      var text = document.createElement('span');
      text.textContent = entry.value;
      cell.appendChild(text);
    }

    function paint() {
      var map = readProperties();
      var filled = 0;
      var swatches = [];

      rows.forEach(function (row) {
        var key = row.dataset.ppPreviewRow;
        var cell = row.querySelector('[data-pp-preview-value]');
        var entry = Object.prototype.hasOwnProperty.call(map, key) ? map[key] : null;
        var isColor = row.dataset.kind === 'color';

        row.classList.toggle('is-filled', !!entry);
        if (entry) {
          filled++;
          if (isColor && entry.swatch) swatches.push(entry.swatch);
        }

        if (cell) paintValue(cell, entry, isColor);
      });

      if (dots) {
        dots.textContent = '';
        swatches.forEach(function (swatch) {
          var dot = document.createElement('i');
          dot.style.setProperty('--pp-chip', swatch);
          dots.appendChild(dot);
        });
      }

      if (progress) {
        progress.textContent = filled + '/' + rows.length + (progressSuffix ? ' ' + progressSuffix : '');
      }

      if (done) done.hidden = filled !== rows.length;
    }

    form.addEventListener('input', paint);
    form.addEventListener('change', paint);
    paint();
  }

  /* ---------- Distanza dall'intestazione fissa ---------- */

  /* La galleria sticky va staccata dall'header, ma solo se l'header è davvero
     fisso: il tema può averlo impostato in tre modi diversi e leggerlo dal DOM
     costa meno che tenere sincronizzato un numero a mano. */
  function stickyOffset() {
    var header =
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-header') ||
      document.querySelector('.section-header');
    if (!header) return 0;

    var position = window.getComputedStyle(header).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;

    return Math.round(header.getBoundingClientRect().height);
  }

  function bindStickyMedia(root) {
    if (!root.classList.contains('pp-pdp--sticky')) return;
    if (!root.querySelector('.pp-pdp__media')) return;

    function sync() {
      root.style.setProperty('--pp-sticky-top', stickyOffset() + 24 + 'px');
    }

    sync();
    window.addEventListener('load', sync);
    window.addEventListener('resize', debounce(sync, 150));
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(fn, wait);
    };
  }

  /* ---------- Avvio ---------- */

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('.pp-pdp');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.ppExtrasReady === 'true') continue;
      nodes[i].dataset.ppExtrasReady = 'true';
      bindGuide(nodes[i]);
      bindPreview(nodes[i]);
      bindStickyMedia(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
